import { AuthSettingsService } from '../services/authsettings.service';
class AuthSettingsServerController implements ng.IComponentController {
   
    constructor(private AuthSettingsService: AuthSettingsService ) {
        'ngInject';
    }

    public $onInit = () => {
        this.AuthSettingsService.all();
    }
}

export const authSettingsServerComponent : ng.IComponentOptions = {
    controller : AuthSettingsServerController,
    template : require('./authsettings.server.html')
};



// WEBPACK FOOTER //
// ./src/app/authsettings/components/authsettings.server.component.ts